<template>    
    <button class="btn btn-secondary sidebar-right-open" @click="close = false">
        <i class="icon icon-chevron-up text-white"></i>
    </button>
    <nav class="sidebar-right" :class="{'close': close }">
        <div class="scrollbar-sidebar">
            <button class="btn btn-secondary sidebar-right-close d-block d-lg-none" @click="close = true" style="">x</button>
           <div class="h-100 p-3 overflow-auto">
                <slot></slot>
           </div>
        </div>
    </nav>
</template>
<script>
    import { reactive, toRefs } from "vue";

    export default {
        components: {
        },
        setup() {
            const e = reactive({
                close: false,
            });
            return { ...toRefs(e) };
        },
    };
</script>